import { createApp, h } from 'vue';
import AsImage from '@awesome-image/image';
import { imageUrlGeneratorFP } from '@awesome-image/services';
import { ObserveVisibility } from 'vue-observe-visibility';

import { VueQueryPlugin } from 'vue-query';
import VueAxios from 'vue-axios';

import FlagIcon from 'vue-flag-icon';
import VueApexCharts from 'vue3-apexcharts';
import CKEditor from '@ckeditor/ckeditor5-vue';
import App from './App.vue';
import router from './router';
import store from './store';
import apiAxios from './services/apiAxios';

import 'ant-design-vue/dist/antd.variable.min.css';
import '@/assets/styles/tailwind.css';
import '@/assets/styles/main.css';
import '@awesome-image/image/dist/style.css';

const app = createApp({
  render: () => h(App),
});

app.directive('observe-visibility', ObserveVisibility);

const vueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchInterval: 1000 * 60 * 10,
      },
    },
  },
};
app.component('apex-chart', VueApexCharts);
app.use(AsImage, {
  responsive: true,
  progressive: true,
  imageUrlGenerator: imageUrlGeneratorFP,
}).use(VueQueryPlugin, vueQueryPluginOptions)
  .use(FlagIcon)
  .use(CKEditor)
  .use(store)
  .use(router)
  .use(VueApexCharts);
app.use(VueAxios, apiAxios);
app.provide('axios', app.config.globalProperties.axios); // provide 'axios'

app.mount('#app');
